module.exports = __webpack_public_path__ + "fonts/DM_Sans-100-latin3.3ccd9ab.woff2";